@if (companyService.company | async; as company) {
  @for (bg of company.bookingProfileGroups; track bg) {
    <div class="flex flex-col">
      <div class="flex flex-col h-10">
        <div class="flex flex-row justify-between items-center w-full" (click)="handleBgClick.emit(bg)">
          <div class="flex-1" style="cursor: pointer">{{ bg.title }}</div>
        </div>
      </div>
    </div>
  }
}
